<template>
    <setting-layout :title="$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.title')">
        <v-container>
            <v-form>
                <v-row v-for="(item, i) in fields" :key="i">
                    <v-col>
                        <div class="pb-1" :class="{'error--text': errors[item.field_name]}">{{ item.label }}</div>
                        <text-field v-if='item.type==="text"'
                                    :placeholder="item.placeholder"
                                    :error-messages="errors[item.field_name]"
                                    v-model="model[item.field_name]"/>
                        <v-select
                            v-else
                            background-color="rgba(237,237,237, .1)"
                            color="orange"
                            :items="item.items"

                            :placeholder="item.placeholder"
                            solo
                            flat
                            item-color="orange"
                            item-text="text"
                            item-value="val"
                            v-model="model[item.field_name]"
                            hide-details


                        ></v-select>
                    </v-col>
                </v-row>
                
                <bottom-control-block :checked="defaultBankTransfer"
                                      days-receive="5-7"
                                      max-days-receive="10"
                                      min-payment="500"
                                      :processing-fee="45"
                                      @change="changeDefault"
                                      :loading="$store.getters.loadingBtn(['setting', 'withdraw', 'directBtn'])"
                                      @done="save">
                </bottom-control-block>

            </v-form>

        </v-container>

        <WithdrawalFormErrorDialog
            v-if="this.isShowWithdrawFormErrorDialog"
            @close="handleCloseWithdrawErrorFormDialog"
        >
            <template #title>
                {{ $t('dialogs.withdrawal_form_error.wire_transfer.title') }}
            </template>

            <template #description>
                {{ $t('dialogs.withdrawal_form_error.wire_transfer.description') }}
            </template>
        </WithdrawalFormErrorDialog>
    </setting-layout>
</template>

<script>
import SettingLayout from "@/layouts/app/profile/SettingLayout";
import TextField from "@/components/app/form/TextField";
import countriesSelect from '@/configs/countriesSelect'
import BottomControlBlock from "@/components/creator/BottomControlBlock";
import { mapActions, mapMutations} from "vuex";
import AccessCameraDialog from "@/components/app/dialogs/AccessCameraDialog.vue";
import WithdrawalFormErrorDialog from "@/components/app/dialogs/WithdrawalFormError.vue";

export default {
    name: "InternationalWireTransfer",
    data() {
        return {
            success: {},
            errors: {},
            model: {},
            defaultBankTransfer: this.$store.state.user.user.data.withdrawDefault === 'international_wire_transfer',
            isShowWithdrawFormErrorDialog: false,
        }
    },
    computed: {
        fields() {
            return [
                {type: 'text', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.placeholder_beneficiary_name'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.beneficiary_name'), field_name: 'beneficiary_name'},
                {type: 'select', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.placeholder_beneficiary_country'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.beneficiary_country'), items: countriesSelect, field_name: 'beneficiary_country'},
                {type: 'text', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.placeholder_beneficiary_street'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.beneficiary_street'), field_name: 'beneficiary_street'},
                {type: 'text', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.placeholder_beneficiary_city'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.beneficiary_city'), field_name: 'beneficiary_city'},
                {type: 'text', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.placeholder_beneficiary_state'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.beneficiary_state'), field_name: 'beneficiary_state'},
                {type: 'text', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.placeholder_beneficiary_zip'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.beneficiary_zip'), field_name: 'beneficiary_zip'},
                {type: 'text', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.placeholder_iban_number'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.iban_number'), field_name: 'iban_number'},
                {type: 'text', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.placeholder_bank_name'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.bank_name'), field_name: 'bank_name'},
                {type: 'select', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.placeholder_bank_country'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.bank_country'), items: countriesSelect, field_name: 'bank_country'},
                {type: 'text', placeholder: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.placeholder_swift_code'), label: this.$t('pages.user.setting.creator.withdraw_options.withdraw.wire_transfer.swift_code'), field_name: 'swift_code'},
            ]
        },
    },
    methods: {
        changeDefault() {
            this.defaultBankTransfer = !this.defaultBankTransfer
            this.$store.state.user.user.data.withdrawDefault = this.defaultBankTransfer ? 'international_wire_transfer' : null
        },
        validateForm(form) {
            for (const key in form) {
                if (form.hasOwnProperty(key)) {
                    const value = form[key]
                    if (value === null || value === undefined || value === '') {
                        return false
                    }
                }
            }
            return true
        },
        save() {
            const isValid = this.validateForm(this.model);
            if (!isValid) {
                this.isShowWithdrawFormErrorDialog = true;
                return;
            }

            this.model.default = this.defaultBankTransfer
            this.sendInternationalWireTransfer({model: this.model})
                .then((result) => {
                    this.success = result || {}
                    this.errors = {}
                    this.showSnackBar(this.$t("dialogs.payment_method.saved"));
                }, (error) => {
                    this.errors = error.response.data.errors || {}
                    this.showSnackBar(this.$t("dialogs.payment_method.not_saved"));
                })
        },
        handleCloseWithdrawErrorFormDialog() {
            this.isShowWithdrawFormErrorDialog = false
        },
        ...mapMutations(["showSnackBar"]),
        ...mapActions([
            'sendInternationalWireTransfer',
            'getInternationalWireTransfer',
        ]),
    },
    mounted() {
        this.getInternationalWireTransfer().then((response) => {
            this.model = response.data || {}
        })
    },
    components: {
        WithdrawalFormErrorDialog,
        AccessCameraDialog,
        BottomControlBlock,
        TextField,
        SettingLayout
    }
}
</script>

<style scoped>

</style>
